/**
 * Prerender (build-time SSR) holati.
 *
 * nginx prerender qilingan HTML ni beradi: `<div id="root" data-prerendered>` ichida
 * tayyor markup bo'ladi va React uni `hydrateRoot` bilan "jonlantiradi". Hydration
 * paytidagi birinchi render server markup'i bilan AYNAN bir xil bo'lishi shart —
 * shuning uchun localStorage/URL query kabi faqat brauzerda ma'lum qiymatlar
 * hydration tugagandan keyin (effect ichida) qo'llanadi.
 */

export function isPrerenderedPage(): boolean {
  if (typeof document === 'undefined') return false;
  return document.getElementById('root')?.hasAttribute('data-prerendered') ?? false;
}

/** Server render yoki prerender qilingan sahifaning birinchi (hydration) renderi. */
let hydrating = typeof window === 'undefined' || isPrerenderedPage();

export function isHydrating(): boolean {
  return hydrating;
}

export function markHydrated() {
  hydrating = false;
}
